var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExclamation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9C18 4.0293 13.9707 0 9 0C4.0293 0 0 4.0293 0 9C0 13.9707 4.0293 18 9 18C13.9707 18 18 13.9707 18 9ZM8 13.9384C8 14.2326 8.09692 14.4836 8.29065 14.6915C8.48645 14.8972 8.7229 15 9 15C9.2771 15 9.51245 14.8972 9.7063 14.6915C9.9021 14.4836 10 14.2326 10 13.9384C10 13.6443 9.9021 13.3943 9.7063 13.1887C9.51245 12.9808 9.2771 12.8768 9 12.8768C8.7229 12.8768 8.48645 12.9808 8.29065 13.1887C8.09692 13.3943 8 13.6443 8 13.9384ZM9 3C8.7229 3 8.48645 3.10395 8.29065 3.31184C8.09692 3.51752 8 3.76744 8 4.06159C8 4.53046 8.07812 10.2819 8.23438 11.1245C8.31433 11.5559 8.53333 11.6907 8.73755 11.7489H9.26245C9.59998 11.6907 9.7063 11.4447 9.76562 11.1245C9.92188 10.2819 10 4.53046 10 4.06159C10 3.76744 9.9021 3.51752 9.7063 3.31184C9.51245 3.10395 9.2771 3 9 3Z",
    fill: "#CB1A38"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclamation);
export default __webpack_public_path__ + "static/media/exclamation.f4538568.svg";
export { ForwardRef as ReactComponent };